'use client';
import { type ReactNode, useState } from 'react';
import type { Session } from 'next-auth';
import * as Sentry from '@sentry/nextjs';

export function SentryInit({ session, children }: { children: ReactNode; session: Session | null }) {
  const [isRendered, setIsRendered] = useState(false);

  if (!isRendered) {
    if (session !== null) {
      Sentry.setUser({ id: session.sub, email: session.email });
      Sentry.setTag('accountId', session.accountID);
      Sentry.setContext('user', {
        email: session.email,
        name: session?.user?.name,
        id: session.sub,
        accountID: session.accountID,
      });
    }
    setIsRendered(true);
  }

  return <>{children}</>;
}
